import appConfig from '../config/basket';

var that;

export default class MiniCartContainer {

    constructor(selectorId) {
        this.container = document.getElementById(selectorId);
        this.totalPrice = 0;
        this.totalQuantity = 0;
        this.items = [];
        that = this;
    }

    addItem(CartMiniItemComponent) {
        this.items.push(CartMiniItemComponent);

        this.totalPrice += parseFloat(CartMiniItemComponent.price()) * parseInt(CartMiniItemComponent.cartItem.quantity);
        this.totalQuantity += parseInt(CartMiniItemComponent.cartItem.quantity);
    }

    setOnDeleteEvent(functionCall) {
        this.deleteEvent = functionCall;
    }

    countTotal() {
        this.totalPrice = 0;
        this.totalQuantity = 0;

        this.items.forEach(function (item) {
            if (this) {
                this.totalPrice += parseFloat(item.price());
                this.totalQuantity += parseInt(item.cartItem.quantity);
            } else {
                that.totalPrice += parseFloat(item.price());
                that.totalQuantity += parseInt(item.cartItem.quantity);
            }
        })
    }

    removeItem(id,itemRemovedCallback) {
        if(itemRemovedCallback === null || itemRemovedCallback === undefined) {
            itemRemovedCallback = function (item) {
            };
        }

        this.totalPrice = 0;
        this.totalQuantity = 0;
        this.items = this.items.filter(item => {

            item.cartItem.quantity = parseInt(item.cartItem.quantity);

            if(item.cartItem.id !== id) {
                this.totalPrice += parseFloat(item.price());
                this.totalQuantity += parseInt(item.cartItem.quantity);
                return item;
            }
            else {
                itemRemovedCallback(item);
            }
        });

        this.showTotal();
    }

    find(id)  {
        return this.items.find(item => {
            return item.id == id;
        });
    }

    removeItems() {
        this.totalPrice = 0;
        this.totalQuantity = 0;
        this.items = [];
    }

    showTotal() {
        document.getElementById('total-amount').innerHTML = `${this.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} <small>${appConfig.currency}</small>`;
    }

    _removeElementsFromDOM() {
        let elements = document.getElementsByClassName('mini-cart-item');

        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    }

    isEmpty(){
        return this.items.length === 0;
    }

    render() {
        this._removeElementsFromDOM();

        this.items.map(item => {
            this.container.appendChild(item.render());
        });

        this.countTotal();
        this.showTotal();
    }
}
